import props from "./../../../src-utils/propDefiner";

export default {
  ...props("autoplay", { type: Number, default: 0 }, "pm-carousel"),
  ...props("slidesToScroll", { type: Number, default: 1 }, "pm-carousel"),
};
